/** localStorage key for sidebar page background preference */
export const SIDEBAR_BACKGROUND_KEY = 'sidebarBackground';

/** localStorage key for color scheme preference */
export const COLOR_SCHEME_KEY = 'colorScheme';

/** localStorage key for custom color palette */
export const CUSTOM_PALETTE_KEY = 'customColorPalette';

/** Default palette for custom (fallback when not set) */
export const DEFAULT_CUSTOM_PALETTE = {
  primary: { main: '#F05454', light: '#ff6b6b', dark: '#c73e3e', contrastText: '#ffffff' },
  secondary: { main: '#DDDDDD', contrastText: '#222831' },
  background: { default: '#30475E', paper: '#222831' },
  text: { primary: '#DDDDDD', secondary: 'rgba(221, 221, 221, 0.7)' },
};

export const getCustomPalette = () => {
  try {
    const v = localStorage.getItem(CUSTOM_PALETTE_KEY);
    if (!v) return DEFAULT_CUSTOM_PALETTE;
    const parsed = JSON.parse(v);
    return { ...DEFAULT_CUSTOM_PALETTE, ...parsed };
  } catch {
    return DEFAULT_CUSTOM_PALETTE;
  }
};

export const setCustomPalette = (palette) => {
  try {
    localStorage.setItem(CUSTOM_PALETTE_KEY, JSON.stringify(palette));
    localStorage.setItem(COLOR_SCHEME_KEY, 'custom');
    window.dispatchEvent(new CustomEvent('colorSchemeChanged', { detail: 'custom' }));
  } catch (e) {
    console.warn('Failed to save custom palette:', e);
  }
};

/** Theme color schemes - affects MUI palette (primary, secondary, background, text) */
export const COLOR_SCHEME_OPTIONS = {
  default: {
    id: 'default',
    label: '默认',
    description: '灰蓝红配色',
    colors: ['#F05454', '#DDDDDD', '#30475E', '#222831'],
    palette: {
      primary: { main: '#F05454', light: '#ff6b6b', dark: '#c73e3e', contrastText: '#ffffff' },
      secondary: { main: '#DDDDDD', contrastText: '#222831' },
      background: { default: '#30475E', paper: '#222831' },
      text: { primary: '#DDDDDD', secondary: 'rgba(221, 221, 221, 0.7)' },
    },
  },
  purplePink: {
    id: 'purplePink',
    label: '紫粉渐变',
    description: '紫粉主题色',
    colors: ['#667eea', '#e947f5', '#171717', '#2d2a3e'],
    palette: {
      primary: { main: '#667eea', light: '#8b9cf0', dark: '#4c5fd5', contrastText: '#ffffff' },
      secondary: { main: '#e947f5', contrastText: '#ffffff' },
      background: { default: '#171717', paper: '#2d2a3e' },
      text: { primary: '#EDEDED', secondary: 'rgba(237, 237, 237, 0.7)' },
    },
  },
  warm: {
    id: 'warm',
    label: '暖色活力',
    description: '珊瑚橙黄绿主题',
    colors: ['#F26076', '#FF9760', '#458B73', '#FFD150'],
    palette: {
      primary: { main: '#F26076', light: '#ff7d90', dark: '#d94a5e', contrastText: '#ffffff' },
      secondary: { main: '#FF9760', contrastText: '#222831' },
      background: { default: '#458B73', paper: '#FFD150' },
      text: { primary: '#ffffff', secondary: 'rgba(255, 255, 255, 0.85)' },
    },
  },
  mintPink: {
    id: 'mintPink',
    label: '薄荷粉',
    description: '薄荷绿与柔粉渐变',
    colors: ['#A8DF8E', '#FFAAB8', '#FFD8DF', '#F0FFDF'],
    palette: {
      primary: { main: '#A8DF8E', light: '#bae99e', dark: '#8fc97a', contrastText: '#222831' },
      secondary: { main: '#FFAAB8', contrastText: '#222831' },
      background: { default: '#FFD8DF', paper: '#F0FFDF' },
      text: { primary: '#b84a6a', secondary: 'rgba(184, 74, 106, 0.75)' },
    },
  },
  custom: {
    id: 'custom',
    label: '自定义',
    description: '自定义主题色',
    colors: [],
    palette: null, // 从 getCustomPalette 获取
  },
};

export const getColorScheme = () => {
  try {
    const v = localStorage.getItem(COLOR_SCHEME_KEY);
    return v && (COLOR_SCHEME_OPTIONS[v] || v === 'custom') ? v : 'default';
  } catch {
    return 'default';
  }
};

export const setColorScheme = (value) => {
  try {
    localStorage.setItem(COLOR_SCHEME_KEY, value);
    window.dispatchEvent(new CustomEvent('colorSchemeChanged', { detail: value }));
  } catch (e) {
    console.warn('Failed to save color scheme preference:', e);
  }
};

/** Available background options */
export const BACKGROUND_OPTIONS = {
  particles: { id: 'particles', label: '粒子动效', description: '白色粒子漂浮效果' },
  floatingLines: { id: 'floatingLines', label: '线条流动', description: '紫粉线条流动效果' },
  prism: { id: 'prism', label: '棱镜', description: '3D 棱镜光效旋转' },
  lightPillar: { id: 'lightPillar', label: '光柱', description: '紫粉渐变光柱流动' },
  colorBends: { id: 'colorBends', label: '色彩弯曲', description: '流动色彩弯曲效果' },
};

export const getSidebarBackground = () => {
  try {
    const v = localStorage.getItem(SIDEBAR_BACKGROUND_KEY);
    if (v === 'grainient') return 'floatingLines'; // 已移除，迁移到线条流动
    return v && BACKGROUND_OPTIONS[v] ? v : 'floatingLines';
  } catch {
    return 'floatingLines';
  }
};

export const setSidebarBackground = (value) => {
  try {
    localStorage.setItem(SIDEBAR_BACKGROUND_KEY, value);
    window.dispatchEvent(new Event('sidebarBackgroundChanged'));
  } catch (e) {
    console.warn('Failed to save background preference:', e);
  }
};
